<script>
    import { onMount } from 'svelte';
    
    let items = [], customproduct;
    export let selecteditems = [];
    onMount(async () => {
        items = await fetch('/assets/itemlist.json').then(res => {return res.json()});
    });

    function itemSearch(field) {
        var input, filter, ul, li, a, i, txtValue;
        input = document.getElementById(field + '-search');
        filter = input.value.toUpperCase();
        ul = document.getElementById(field);
        li = ul.getElementsByTagName('div');

        for (i = 0; i < li.length; i++) {
            a = li[i];
            txtValue = a.getAttribute('data-item');
            if (txtValue.toUpperCase().indexOf(filter) > -1) {
                li[i].style.display = '';
            } else {
                li[i].style.display = 'none';
            }
        }
    }
</script>

<div class="flex flex-row items-start justify-between bg-gray-100">
    <div class="flex flex-col items-center justify-start flex-1 px-2 overflow-y-auto max-h-96 h-96">
        <div class="flex flex-row items-center justify-between w-full">
            <p class="py-1 text-lg text-left">Added Products</p>
            <p class="py-1 text-right cursor-pointer select-none text-md hover:underline" on:click={() => {document.getElementById('customproduct-wrapper').classList.toggle('hidden')}}>Add Custom Product</p>
        </div>

        <div id="customproduct-wrapper" class="flex flex-col items-center justify-between hidden w-full py-5">
            <input id="customproduct-input" bind:value={customproduct} placeholder="Custom Product Name" class="w-full p-1 my-2">
            <button on:click={() => {selecteditems = [...selecteditems, {'item': customproduct, 'price': 1, 'qty': 64}]; customproduct='Custom Product'; document.getElementById('customproduct-wrapper').classList.toggle('hidden');}} class="w-full p-1 mb-2 font-bold bg-green-300 hover:bg-green-200">Add '{customproduct || 'Custom Product'}'</button>
        </div>

        <input id="selecteditems-search" on:keyup={() => itemSearch('selecteditems')} on:contextmenu|preventDefault={() => { document.getElementById('selecteditems-search').value = ''; itemSearch('selecteditems'); }} placeholder="Search..." class="sticky top-0 w-full p-2 border border-black outline-none">
        <div class="flex flex-col items-center justify-start w-full pt-2" id="selecteditems">
            {#each selecteditems as item, i}
                <div class="flex flex-row items-center justify-start w-full p-1 text-left cursor-pointer select-none hover:bg-gray-300" data-item={item.item}>
                    <p on:click={() => {selecteditems.splice(i, 1); selecteditems = selecteditems;}} class="px-1 mr-2 font-semibold hover:bg-gray-200 hover:text-red-500">X</p>
                    <p class="flex-1"><i class="icon-minecraft mr-2 {items.filter(a => a.label == item.item).length > 0 ? items.filter(a => a.label == item.item)[0].css : 'hidden'}" />{item.item}</p>
                    <input class="w-12 pb-1 text-center bg-transparent border-b border-black outline-none noi" type="number" placeholder="64" bind:value={selecteditems[i].qty}>
                    <p class="px-2">per</p>
                    <input class="w-12 pb-1 text-center bg-transparent border-b border-black outline-none noi" type="number" placeholder="1" bind:value={selecteditems[i].price}>
                    <p class="pl-2"> Dia</p>
                </div>
            {/each}
        </div>
    </div>
    
    <div class="flex flex-col items-center justify-start flex-1 px-2 overflow-y-auto max-h-96 h-96">
        <p class="py-1 text-lg">All Items</p>
        <input id="items-search" on:keyup={() => itemSearch('items')} on:contextmenu|preventDefault={() => { document.getElementById('items-search').value = ''; itemSearch('items'); }} placeholder="Search..." class="sticky top-0 w-full p-2 border border-black outline-none">
        <div class="flex flex-col items-center justify-start w-full pt-2" id="items">
            {#each items as item}
                <div class="flex flex-row items-center justify-start w-full p-1 text-left cursor-pointer select-none hover:bg-gray-300" data-item={item.label} on:click={() => {selecteditems = [...selecteditems, {'item': item.label, 'price': 1, 'qty': 64}];}}>
                    <p class="flex-1"><i class="icon-minecraft mr-2 {item.css}" />{item.label}</p>
                </div>
            {/each}
        </div>
    </div>
</div>

<style>
    input:not(.noi) {
        @apply w-full p-2 border border-black outline-none;
    }
</style>

